import React from 'react'

export default props => (
  <svg viewBox="0 0 13 8" {...props}>
    <path d="M3,-1.43275066 L9,4.97074536 L10,3.90349602 L4,-2.5 L3,-1.43275066 L3,-1.43275066 Z M4,10.5 L10,4.09650398 L9,3.02925464 L3,9.43275066 L4,10.5 L4,10.5 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/arrow.js